import DentalImplantsRFV from '@/assets/SVG/DentalImplantsRFV';

import { reasonForVisitStyles } from './ReasonForVisit.styles';

export const DentalImplants = () => (
	<div
		style={
			{
				...reasonForVisitStyles.reasonForVisitIcon,
				...reasonForVisitStyles.reasonForVisitIconDentalImplants,
			} as React.CSSProperties
		}
	>
		<DentalImplantsRFV />
	</div>
);
